import styled from '@emotion/styled';
import React from 'react';

import { CardIcon } from 'src/modules/programs/cpProgram/components/styles';
import * as S from 'src/modules/programs/stepComponents/styles';
import { color, font } from 'src/shared/styles/variables';

import thumbDownIconRed from 'src/public/img/icon-thumb-down.svg';
import thumbUpIconBlue from 'src/public/img/icon-thumbs-up.svg';

const StyledDisadvise = styled('p')(
    {
        margin: '0.5rem 0 1rem 0',
        color: color.bittersweet,
    },
    font.book(font.size.medium),
);

const StyledAdvise = styled('p')(
    {
        marginTop: '0.5rem',
        color: color.blueLagoon,
    },
    font.book(font.size.medium),
);

interface GoalSettingTips {
    description: string;
    disadvise: string;
    advise: string;
}

interface Props {
    list: GoalSettingTips[];
}

export const GoalSettingTipsContent: React.SFC<Props> = ({ list }) => (
    <>
        {list.map(element => (
            <React.Fragment key={element.description}>
                <S.StepDescription small>{element.description}</S.StepDescription>
                <CardIcon smallIcon iconUrl={thumbDownIconRed} />
                <StyledDisadvise>{element.disadvise}</StyledDisadvise>
                <CardIcon smallIcon iconUrl={thumbUpIconBlue} />
                <StyledAdvise>{element.advise}</StyledAdvise>
            </React.Fragment>
        ))}
    </>
);
